import { render } from "./ResearchThumb.vue?vue&type=template&id=2f29e14b&scoped=true&bindings={}"
import script from "./ResearchThumb.vue?vue&type=script&lang=ts"
export * from "./ResearchThumb.vue?vue&type=script&lang=ts"

import "./ResearchThumb.vue?vue&type=style&index=0&id=2f29e14b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2f29e14b"

export default script